import { makeVar } from '@apollo/client';

const currencyVar = makeVar('');

export default currencyVar;
